import PickerUI from 'emoji-picker-react';
import { Box } from 'material-hu';

export type PickerProps = any;

export const Picker: typeof PickerUI = props => {
  return (
    <Box
      sx={{
        '& .EmojiPickerReact': {
          '& .epr-category-nav': {
            py: '2px',
          },
          '--epr-emoji-size': '25px',
        },
      }}
    >
      <PickerUI
        skinTonesDisabled
        width="100%"
        previewConfig={{ showPreview: false }}
        {...props}
      />
    </Box>
  );
};

export default Picker;
